var render = function render(){var _vm=this,_c=_vm._self._c;return _c('multiselect',{attrs:{"options":_vm.options,"track-by":"key","label":"value","multiple":false,"allowEmpty":!!_vm.allowEmpty,"placeholder":"Tratamiento","selectedLabel":"","selectLabel":"","deselectLabel":""},on:{"input":_vm.notifyChange},model:{value:(_vm.option),callback:function ($$v) {_vm.option=$$v},expression:"option"}})
}
var staticRenderFns = []

export { render, staticRenderFns }